import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class DashboardService extends GenericService {
    constructor() {
        super('/dashboard', axiosInstance);
    }

    async getStats() {
        try {
            const response = await this.axios.get(`${this.baseUrl}/stats`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getYearlySales(year = null) {
        try {
            const params = year ? `?year=${year}` : '';
            const response = await this.axios.get(`${this.baseUrl}/yearly-sales${params}`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getLegacyStats() {
        try {
            const response = await this.axios.get(`${this.baseUrl}/legacy-stats`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getSalesByLocation() {
        try {
            const response = await this.axios.get(`${this.baseUrl}/sales-by-location`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getBranchComparison() {
        try {
            const response = await this.axios.get(`${this.baseUrl}/branch-comparison`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getTopEmployees() {
        try {
            const response = await this.axios.get(`${this.baseUrl}/top-employees`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getRecentCustomers(params = {}) {
        try {
            const response = await this.axios.get(`${this.baseUrl}/recent-customers`, { params });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getRecentPayments(params = {}) {
        try {
            const response = await this.axios.get(`${this.baseUrl}/recent-payments`, { params });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getRecentStockUsage() {
        try {
            const response = await this.axios.get(`${this.baseUrl}/recent-stock-usage`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getRevenueTrend(params = {}) {
        try {
            const response = await this.axios.get(`${this.baseUrl}/revenue-trend`, { params });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getPaymentMethodsSummary(params = {}) {
        try {
            const response = await this.axios.get(`${this.baseUrl}/payment-methods-summary`, { params });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getStockUsageTrend(params = {}) {
        try {
            const response = await this.axios.get(`${this.baseUrl}/stock-usage-trend`, { params });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }
}

export default new DashboardService();
